import { useEffect, useState, useRef } from 'react'
import debounce from 'lodash/debounce'

// 控制是否展示手气展开的 hook
function useNeedFoldView({ list }: { list?: any[] }) {
  const contentWrapRef = useRef(null)
  const [needFold, setNeedFold] = useState(false)
  const [showMore, setShowMore] = useState(false)

  const handleGetListWidth = () => {
    const contentHeight = contentWrapRef.current?.offsetHeight
    // 校验是否需要展示展开收起按钮
    const needShowMoreBtn = contentHeight > 36 + 18
    setNeedFold(needShowMoreBtn)
    setShowMore(true)
  }

  useEffect(() => {
    if (list) {
      handleGetListWidth()
    }
  }, [list])

  useEffect(() => {
    const callback = debounce(handleGetListWidth, 500)
    window.addEventListener('resize', callback)

    return () => {
      window.removeEventListener('resize', callback)
    }
    // eslint-disable-next-line
  }, [])

  return {
    contentWrapRef,
    needFold,
    showMore,
    setShowMore
  }
}

export default useNeedFoldView
